import { render, staticRenderFns } from "./Koutu_Explain.vue?vue&type=template&id=5b5adf76&scoped=true"
import script from "./Koutu_Explain.vue?vue&type=script&lang=js"
export * from "./Koutu_Explain.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Explain.vue?vue&type=style&index=0&id=5b5adf76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5adf76",
  null
  
)

export default component.exports